import { render, staticRenderFns } from "./StepPhosphorusRequirement.vue?vue&type=template&id=75b99c76&scoped=true&"
import script from "./StepPhosphorusRequirement.vue?vue&type=script&lang=js&"
export * from "./StepPhosphorusRequirement.vue?vue&type=script&lang=js&"
import style0 from "./StepPhosphorusRequirement.vue?vue&type=style&index=0&id=75b99c76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b99c76",
  null
  
)

export default component.exports